import { FC, memo } from 'react'

import { countries } from 'commons/types/dictionaries'
import { determineIssuingStateData } from 'commons/utils'
import { Select } from 'ui/components'
import { FieldSet } from 'ui/components/FieldSet'
import { TextInput } from 'ui/components/InputV2'
import { Col, FormRow } from 'ui/themes/globalStyles'

import { AddressInformationProps } from './AddressInformationProps'

export const AddressInformation: FC<AddressInformationProps> = memo(({ Field, config }) => (
  <FieldSet legend="Physical Address">
    <FormRow>
      <Col>
        <Field
          name="street"
          label="Street"
          input={TextInput}
          inputProps={{
            'data-qa': 'Physical Address Street'
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="city"
          label="City"
          input={TextInput}
          inputProps={{
            'data-qa': 'Physical Address City'
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="state"
          label="State/Province"
          input={Select}
          inputProps={{
            'data-qa': 'Physical Address State/Province',
            'options-data-qa': 'Physical Address State/Province',
            data: determineIssuingStateData(config.value.country)
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="country"
          label="Country"
          input={Select}
          inputProps={{
            'data-qa': 'Physical Address Country',
            'options-data-qa': 'Physical Address Country',
            data: countries
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="postalCode"
          label="Zip/Postal Code"
          input={TextInput}
          inputProps={{
            'data-qa': 'Physical Address Zip/Postal Code'
          }}
        />
      </Col>
    </FormRow>
  </FieldSet>
))
